// extracted by mini-css-extract-plugin
export default {"actionButtons":"package_actionButtons__-goOG","badgeClassOverride":"package_badgeClassOverride__+GTP7","label":"package_label__fwaNN"};